module.exports = __webpack_public_path__ + "static/img/a_zhang.bb45adcf.png";